import React from "react";
import PriceCardFeature from "~/landingPage/pages/influencersPage/components/PriceCardFeature";

export default function PriceCard({
  price,
  isFree,
  frequency,
  newPriceText,
  topText,
  isBestOffer,
  onClick,
}) {
  return (
    <div
      className={`bg-gray-50 w-[250px] md:w-[300px] h-[400px] shadow-xl md:m-6 m-2 rounded-xl p-4 flex flex-col justify-between border-2 ${
        isBestOffer ? "border-tertiary" : ""
      }`}
    >
      <div>
        <p className={`text-gray-500 italic text-sm`}>{topText}</p>
      </div>
      <div>
        <div className="flex items-end mb-1">
          {isFree ? (
            <p className="mb-0.5 md:text-4xl text-3xl">Gratuit</p>
          ) : (
            <>
              <p className="mr-2 md:text-5xl text-3xl">{price}€</p>
              <p>par {frequency}</p>
            </>
          )}
        </div>
        <div className="flex items-end mb-10 italic min-h-[18px]">
          {newPriceText ? (
            <p className="mb-0.5 text-xs text-gray-500">{newPriceText}</p>
          ) : (
            <></>
          )}
        </div>
        <PriceCardFeature
          text={"Swiper et entrer en contact"}
          isAvailable={true}
        />
        <PriceCardFeature
          text={"Ajouter une vidéo à votre profil"}
          isAvailable={!isFree}
        />
        <PriceCardFeature
          text={"1 Super Like par semaine"}
          isAvailable={!isFree}
        />
        <PriceCardFeature
          text={"Revenir sur un profil passé"}
          isAvailable={!isFree}
        />
        <PriceCardFeature text={"Voir qui vous a liké"} isAvailable={!isFree} />
      </div>
      <div className="flex justify-center">
        <div
          className="self-end uppercase w-full text-center h-fit bg-primary rounded-lg px-4 py-1 text-white border-2 font-bold text-md cursor-pointer hover:bg-white hover:text-primary border-primary transition duration-200"
          onClick={onClick}
        >
          S'inscrire
        </div>
      </div>
    </div>
  );
}
